enum CURRENCY_LOCALE {
  DEFAULT = undefined,
  TYPE_DE = "de-DE",
  TYPE_JP = "ja-JP",
}
export {CURRENCY_LOCALE};
